import axios from "axios";
import { getUploadFileHeader } from "../../utils";
 
const commonFormData = (medicalUserCode , pendingWith , attachment   )=>{
        const formData = new FormData();
            formData.append('medicalUserCode', medicalUserCode);
            formData.append('pendingWith', pendingWith);
            formData.append('attachment', attachment);
            return formData
         }
 
    export const chronicFile=  async(chronicFile , model  , name  )=>{
      
     
     if(chronicFile.length>0){
          const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
          const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
          
              let formData =  commonFormData ( model.medicalId , model.pendingWith , chronicFile[0]  )
              let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
              let fileModel = fileDetail.data 
              fileModel.chargesType = name
               
              let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
           
     }  
   
}


 
export const specialFile=  async(specialFile , model  , name  )=>{
  
    if(specialFile.length>0){
     const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
      let formData =  commonFormData ( model.medicalId , model.pendingWith , specialFile[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )

    }
  
}

      

         
      
export const consultationChargesFiles=  async(consultationChargesFiles , model  , name  )=>{
    
     
    const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
    const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
    
    if(consultationChargesFiles.length>1){
         let totalLength = consultationChargesFiles.length
        for (let i = 0; i < totalLength; i++) {
                        const item = consultationChargesFiles[i];
                        let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                        let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
                        let fileModel = fileDetail.data 
                        fileModel.chargesType = name

                        let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
                        
                 }
            }
         else if(consultationChargesFiles.length==1)  { 
        let formData =  commonFormData ( model.medicalId , model.pendingWith , consultationChargesFiles[0]  )
        let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
        let fileModel = fileDetail.data 
        fileModel.chargesType = name
        let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
          
                 

       }
     
}






         
export const medicineCostFiles =  async(medicineCostFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(medicineCostFiles.length>1){
       let totalLength = medicineCostFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = medicineCostFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
                      
               }
          }
          else if(medicineCostFiles.length==1)  { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , medicineCostFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
   
     }
   
}




export const pathologicalChargesFiles =  async(pathologicalChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(pathologicalChargesFiles.length>1){
       let totalLength = pathologicalChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = pathologicalChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
                      
               }
          }
          else if(pathologicalChargesFiles.length==1) { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , pathologicalChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }
   
}






export const physiothrapyChargesFiles =  async(physiothrapyChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(physiothrapyChargesFiles.length>1){
       let totalLength = physiothrapyChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = physiothrapyChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(physiothrapyChargesFiles.length==1)  { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , physiothrapyChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}



export const operationChargesFiles  =  async(operationChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(operationChargesFiles.length>1){
       let totalLength = operationChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = operationChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(operationChargesFiles.length==1)  { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , operationChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      let uploadedFileEntry = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}






export const operationTheatreChargesFiles  =  async(operationTheatreChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(operationTheatreChargesFiles.length>1){
       let totalLength = operationTheatreChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = operationTheatreChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(operationTheatreChargesFiles.length==1)  { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , operationTheatreChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}




     
export const anaesthesiaChargesFiles  =  async(anaesthesiaChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(anaesthesiaChargesFiles.length>1){
       let totalLength = anaesthesiaChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = anaesthesiaChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(anaesthesiaChargesFiles.length==1)   { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , anaesthesiaChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}







     
export const roomIcuChargesFiles  =  async(roomIcuChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(roomIcuChargesFiles.length>1){
       let totalLength = roomIcuChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = roomIcuChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      = await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(roomIcuChargesFiles.length==1)   { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , roomIcuChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}


export const injectionChargesFiles  =  async(injectionChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(injectionChargesFiles.length>1){
       let totalLength = injectionChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = injectionChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(injectionChargesFiles.length==1)  { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , injectionChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}




     
export const disposalChargesFiles  =  async(disposalChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(disposalChargesFiles.length>1){
       let totalLength = disposalChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = disposalChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(disposalChargesFiles.length==1) { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , disposalChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}

        
export const dentalChargesFiles  =  async(dentalChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(dentalChargesFiles.length>1){
       let totalLength = dentalChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = dentalChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                     

                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(dentalChargesFiles.length==1)   { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , dentalChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}


   
        
export const otherChargesFiles  =  async(otherChargesFiles , model  , name  )=>{   
  const url = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment`;
  const updateUploadedFileUrl = `${process.env.REACT_APP_BASE_URL}medicalclaim/attachment/file/upload`;
  
  if(otherChargesFiles.length>1){
       let totalLength = otherChargesFiles.length
      for (let i = 0; i < totalLength; i++) {
                      const item = otherChargesFiles[i];
                      let formData =  commonFormData ( model.medicalId , model.pendingWith , item  )
                      let fileDetail = await axios.post( url , formData , getUploadFileHeader() )
                      let fileModel = fileDetail.data 
                      fileModel.chargesType = name
                      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
               }
          }
          else if(otherChargesFiles.length==1) { 
      let formData =  commonFormData ( model.medicalId , model.pendingWith , otherChargesFiles[0]  )
      let fileDetail = await axios.post(url, formData , getUploadFileHeader() )
      let fileModel = fileDetail.data 
      fileModel.chargesType = name
      await axios.post(updateUploadedFileUrl, fileModel , getUploadFileHeader() )
     }  
}
